<template>
  <div>
    <div class="topAd" v-show="topAdImg">
      <img :src="topAdImg" alt="">
      <i @click="deleteTopAd" class="el-icon-error"></i>
    </div>
    <div class="header">
      <div class="content">
        <div class="left">
          <ul>
            <li>
              <el-button @click="collectionClick" type="text" :icon="collection ? 'el-icon-star-off' : 'el-icon-star-on'">
                {{ collection ? '收藏本站' : '已收藏' }}
              </el-button>
            </li>
            <!-- <li v-for="(item,index) in leftList" :key="index">
              <el-button @click="menuClick(item.type)" type="text" :icon="item.icon">{{item.text}}</el-button>
            </li> -->
          </ul>
        </div>
        <div class="middle"></div>
        <div class="right">
          <ul v-show="!isLogin">
            <li><el-button type="text" @click="menuClick('Login')">登录</el-button></li>
            <li><span class="shu">丨</span></li>
            <li><el-button type="text" @click="menuClick('Register')">注册</el-button></li>
          </ul>
          <ul>
            <li v-show="isLogin">
              <el-dropdown
              trigger="click"
              @visible-change="visibleChange"
              placement="bottom-start"
              @command="menuClick">
                <span class="el-dropdown-link">
                  {{userName}}<i :class="iconType" class="el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in userMenuList" :key="index" :command="item.pathName" >{{item.text}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <!-- <li><span class="shu">丨</span></li> -->
            <!-- <li>
              <el-button type="text" @click="menuClick('code')">图书兑换码</el-button>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      iconType: 'el-icon-arrow-down',
      userName: '',
      collection: true,
      isLogin: false,
      topAdImg: '',
      leftList: [{
        text: '官方微信',
        icon: 'el-icon-location',
        type: 'wx'
      }, {
        text: '官方微博',
        icon: 'el-icon-view',
        type: 'wb'
      }],
      userMenuList: [{
        text: '我的书架',
        type: 'bookshelf',
        pathName: 'MyBookshelf'
      }, {
        text: '我的订单',
        type: 'order',
        pathName: 'MyOrder'
      }, {
        text: '我的收藏',
        type: 'collection',
        pathName: 'MyCollection'
      },
      // {
      //   text: '我的购书记录',
      //   type: 'record',
      //   pathName: 'MyRecord'
      // },
      // {
      //   text: '我的优惠券',
      //   type: 'coupon',
      //   pathName: 'MyCoupon'
      // },
      {
        text: '账号设置',
        type: 'setup',
        pathName: 'Settings'
      }, {
        text: '退出',
        type: 'signout',
        pathName: ''
      }]
    }
  },
  methods: {
    visibleChange (type) {
      if (type) {
        this.iconType = 'el-icon-arrow-up'
      } else {
        this.iconType = 'el-icon-arrow-down'
      }
    },
    menuClick (pathName) { // 菜单操作
      if (pathName) {
        this.$router.push({
          name: pathName
        })
      } else {
        this.$confirm('是否退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.sessionStorage.removeItem('ysUserMsg')
          this.$store.dispatch('update_userMsg', {})
          this.isLogin = false
          this.userName = ''
          if (this.$route.name !== 'Home') {
            this.$router.push({
              name: 'Home'
            })
          }
        }).catch(() => {
        })
      }
    },
    collectionClick () {
      this.collection = !this.collection
    },
    getTopAd () { // 获取顶部广告图片
      this.$get(this.$allUrl.getTopAd).then(res => {
        if (res.code === '0') {
          const imgAdmin = this.$allUrl.imgAdmin
          this.topAdImg = imgAdmin + res.data.imageUrl
        } else {
          this.topAdImg = false
        }
      })
    },
    deleteTopAd () { // 关闭广告
      this.topAdImg = ''
    }
  },
  mounted () {
    this.getTopAd()
    const userMsg = this.$store.state.userMsg
    if (userMsg.id) {
      this.isLogin = true
      this.userName = userMsg.userName
    }
  }
}
</script>
<style lang="less" scoped>
  .topAd{
    height: 80px;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
    i{
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 24px;
      cursor: pointer;
      color: white;
    }
  }
  .header{
    height: 40px;
    background-color: #F5F5F5;
    border-bottom: 1px solid #D6D6D6;
    ul{
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      li{
        margin: 0 10px;
        line-height: 40px;
        button{
          color: #240C10;
        }
        .shu{
          color: #D5D5D5;
        }
        .el-dropdown-link{
          cursor: pointer;
        }
      }
    }
    .content{
      display: flex;
      .right{
        display: flex;
      }
      .middle{
        flex: 1
      }
    }
  }
  .el-dropdown-menu{
    width: 126px;
  }
</style>



// WEBPACK FOOTER //
// src/base/header/header.vue